// /forgot-password (FR-038; routes.md).
import { ForgotPasswordScreen } from "@/auth/email/ForgotPasswordScreen";

export default function ForgotPassword() {
  return <ForgotPasswordScreen />;
}
